<template>
  <div class="range">
    <div class="range__title" :class="{ 'display-only': !canEdit }">
      <div class="title__content">
        {{ $t(dayName) }}
      </div>
      <div class="btn-add" @click="addHourRange(day)" v-if="canEdit">
        <svgicon src="icon/circle-add.svg" height="16" width="16" />
      </div>
    </div>

    <div class="time" :class="{ time__display: !canEdit }" v-for="(hour, hourIndex) in day.hours" :key="hourIndex">
      <select class="hourSelect" v-model="hour.from" @change="$forceUpdate()" v-if="canEdit">
        <option :value="formatHour(n - 1)" v-for="n in max" :key="'from' + n">{{ formatHour(n - 1, true) }}</option>
      </select>
      <div class="hour-display" v-if="!canEdit">
        {{ hour.from }}
      </div>
      <span class="divider">{{ $t('to') }}</span>
      <template v-if="canEdit">
        <select class="hourSelect" v-model="hour.to" @change="$forceUpdate()">
          <option :value="formatHour(n - 1)" v-for="n in max" :key="'to' + n">{{ formatHour(n - 1, true) }}</option>
        </select>
        <div class="btn-remove" @click="removeHourRange(day, hourIndex)"
          v-if="$store.getters.loggedUserHasModifyPermission">
          <svgicon src="/icon/circle-remove.svg" height="16" width="16" />
        </div>
      </template>
      <div class="hour-display" v-if="!canEdit">
        {{ hour.to }}
      </div>
    </div>
    <div v-if="day.hours < 1" class="time no-hours" :class="{ closed: noHoursAsClosed }">
      {{ noHoursAsClosed ? $t('closed') : $t('no_hours') }}
    </div>
  </div>
</template>

<script>
  export default {

    name: "DayTimeRange",

    props: {
      day: {},
      context: "",
      dayName: "",
      errorsKey: String,
      validate: Object,
      max24: Boolean,
      displayOnly: Boolean,
      noHoursAsClosed: Boolean
    },

    data() {
      return {
        twelveHourFormat: false,
        max: this.max24 ? 97 : 121
      }
    },

    computed: {
      canEdit() {
        return this.$store.getters.loggedUserHasModifyPermission && !this.displayOnly;
      }
    },

    async mounted() {
      let company = await this.$store.getters.getContextCompany;
      this.twelveHourFormat = company && company.hourFormat === '12';
    },

    methods: {
      addHourRange(day) {
        day.hours.push({
          from: "",
          to: ""
        });
        this.$forceUpdate();
      },
      removeHourRange(day, index) {
        day.hours.splice(index, 1);
        this.$forceUpdate();
      },
      formatHour(n, formatted = false) {
        let hour = Math.floor(n / 4);
        let minute = n % 4 * 15;

        if (!formatted) {
          return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`
        }

        let tomorrow = hour >= 24;
        hour = hour % 24;

        let suffix = '';
        if (this.twelveHourFormat) {
          suffix = 12 <= hour && hour <= 23 ? ' PM' : ' AM';
          hour = hour % 12;
          if (hour === 0) {
            hour = 12
          }
        }

        let hourFormatted = hour.toString().padStart(2, '0');
        let minFormatted = minute.toString().padStart(2, '0');

        return tomorrow
          ? `${hourFormatted}:${minFormatted}${suffix} (+1)`
          : `${hourFormatted}:${minFormatted}${suffix}`;
      }
    }

  }
</script>

<style lang="scss" scoped>
  .range {
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 0 0 0px 16px;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    .range__title {
      font-weight: bold;
      font-size: 14px;
      color: #1a1a1a;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.display-only {
        height: 48px
      }
    }

    .btn-add,
    .btn-remove {
      padding: 16px;
      cursor: pointer;
    }

    .svgicon {
      fill: var(--primary-color);
    }
  }

  .open {
    justify-content: space-between;
  }

  .time,
  .open {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    &.no-hours {
      font-size: 14px;
      color: #808080;
      font-style: italic;

      &.closed {
        color: #ed2937;
      }
    }
  }

  .divider {
    padding: 0 10px;
    font-size: 14px;
    color: #808080;
  }

  .time__display {
    justify-content: flex-start;
    height: 48px;
  }

  select {
    padding: 5px 0px 5px 10px;
    color: #1a1a1a;
    border-radius: 6px;
    line-height: 1;
    flex-grow: 1;
    font-size: 16px;
  }

  @media screen and (max-width: 600px) {
    .time:not(.time__display) {
      flex-wrap: wrap;

      &:not(:last-of-type) {
        margin-bottom: 20px;
      }

      select:not(:last-of-type) {
        margin-right: 48px;
      }

      .divider {
        padding: 10px 10px;
        flex-basis: 100%
      }
    }
  }
</style>